import { isAndroid, isIOS } from "mobile-device-detect";

const useDevice = () => {
  //此hook用於判斷iOS,Android
  //iOS的話會多回傳iOS版本號

  const iOS_version = () => {
    if (isIOS) {
      var v = window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [
        parseInt(v?.[1], 10),
        parseInt(v?.[2], 10),
        parseInt(v?.[3] || 0, 10),
      ];
    }
  };

  const iOS_ver = iOS_version(); //16.7.2 會是這樣 [16,7,2]

  return {
    deviceType: isAndroid ? "Android" : isIOS ? "iOS" : null,
    deviceVersion: isIOS ? iOS_ver : null,
  };
};

export default useDevice;
